import Vue from 'vue'
import Router from 'vue-router'
//import NProgress from 'nprogress'




Vue.use(Router)

function load(component) {
  // '@' is aliased to src/components
  return () => import(`@/${component}.vue`)
}


const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash };
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes: [

    {
      path: "/",
      component: () => import("@/layouts/home/Index.vue"),
      children: [
        {
          path: "",
          name: "Home",
          component: () => import("@/views/home/Home.vue"),
        },
        { path: '/homepage/:slug', redirect: '/' },
        {
          path: "/bloglistingpage/:slug",
          name: "BlogListing",
          props: true,
          component: () => import("@/views/blog/BlogListing.vue"),
        },
        {
          path: "/departmentarticleblogpage/:slug",
          name: "DepartmentBlog",
          props: true,
          component: () => import("@/views/blog/BlogArticle.vue"),
        },
        {
          path: "/articleblogpage/:slug",
          name: "Blog",
          props: true,
          component: () => import("@/views/blog/BlogArticle.vue"),
        },
        {
          path: "aboutpage/:slug",
          name: "About",
          props: true,
          component: () => import("@/views/About.vue")
        },
        {
          path: "/departmentdocumentlistingpage/:slug",
          name: "DepartmentDocumentListing",
          props: true,
          component: load('views/departments/documents/DocumentListing'),
        },
        {
          path: "/subdepartmentdocumentlistingpage/:slug",
          name: "SubDepartmentDocumentListing",
          props: true,
          component: load('views/departments/documents/DocumentListing'),
        },
        {
          path: "/documentlistingpage/:slug",
          name: "DocumentListing",
          props: true,
          component: () => import("@/views/departments/documents/DocumentListing.vue"),
        },
        {
          path: "/departmentlandingpage/:slug",
          name: "DepartmentLandingPage",
          props: true,
          component: () => import("@/views/departments/landingPage/landingPage.vue")
        },
        {
          path: "/departmentbloglistingpage/:slug",
          name: "DepartmentlogListing",
          props: true,
          component: () => import("@/views/blog/BlogListing.vue"),
        },
        {
          path: "/departmentaboutpage/:slug",
          name: "DepartmentAbout",
          props: true,
          component: () => import("@/views/About.vue")
        },
        {
          path: "/departmentdocument/:slug",
          name: "DepartmentDocument",
          props: true,
          component: () => import("@/views/departments/documents/Document.vue"),
        },
        {
          path: "/contactpage/:slug",
          name: "ContactPage",
          props: true,
          component: () => import("@/views/contact/Contact.vue")
        },
        {
          path: "/departmentcontactpage/:slug",
          name: "DepartmentContactPage",
          props: true,
          component: () => import("@/views/contact/Contact.vue")
        },
        {
          path: "/eventindex/:slug",
          name: "EventListingPage",
          props: true,
          component: () => import("@/views/events/EventListing.vue")
        },
        {
          path: "/departmenteventindex/:slug",
          name: "DepartmentEventListingPage",
          props: true,
          component: () => import("@/views/events/EventListing.vue")
        },
        {
          path: "/event/:slug",
          name: "Event",
          props: true,
          component: () => import("@/views/events/EventArticle.vue"),
        },
        {
          path: "/calendar/",
          name: "Calendar",
          component: () => import("@/views/OurCalendar.vue"),
        },
        {
          path: "/comingsoon/:slug",
          name: "ComingSoon",
          props: true,
          component: () => import("@/views/comingSoon/comingSoon.vue"),
        },
        {
          path: "/test/test",
          name: "Test",
          props: true,
          component: () => import("@/prototypes/DocumentSuperSearchPrototype.vue"),
        },
        {
          path: "/test/test2",
          name: "contact_form",
          props: true,
          component: () => import("@/components/forms/chairman/contact_form.vue"),
        },
        {
          path: "/login",
          name: "HomeLogin",
          component: () => import("@/views/home/Home.vue"),

          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/404",
          name: "404",
          component: () => import("@/views/error/404.vue"),
        },
        { path: '*', redirect: '/404' },
      ],
    },
  ],
});

// router.beforeEach((to, from, next) => {
//   if (to.meta.requiresAuth) {
//     const auth = store.state.security.auth
//     if (!auth.authenticated) {
//       security.init(next, to.meta.roles)
//     }
//     else {
//       if (to.meta.roles) {
//         if (security.roles(to.meta.roles[0])) {
//           next()
//         }
//         else {
//           next({ name: 'unauthorized' })
//         }
//       }
//       else {
//         next()
//       }
//     }
//   }
//   else {
//     next()
//   }
// })

router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (router.app.$keycloak.authenticated) {
      console.log(router.app.$keycloak.realmAccess)
      next()
    } else {
      const loginUrl = router.app.$keycloak.createLoginUrl({ 'redirectUri': 'https://washoetribe.us' + to.fullPath })
      window.location.replace(loginUrl)
    }
  } else {
    next()
  }
})



/* Looks like it's working, just not actually showing the thing. Says to include the js and css files in my project, but I don't know where. */

// router.beforeResolve((to, from, next) => {
//   // If this isn't an initial page load.
//   if (to.name) {
//       // Start the route progress bar.
//       NProgress.start()
//       console.log("start??")
//   }
//   console.log(from)
//   next()
// })

// router.afterEach((to, from) => {
//   // Complete the animation of the route progress bar.
//   NProgress.done()
//   console.log(to)
//   console.log(from)
// })

export default router;
